<template>
  <div class="text-center section">
    <div class="d_flex_btwn mb_10">
      <h2 class="h2">Leave Calendar</h2>
      <h4 class="color_green">
        <router-link :to="{ name: 'leave-requests' }"
          >View leave requests</router-link
        >
      </h4>
    </div>
    <v-calendar
      class="custom-calendar max-w-full"
      :masks="masks"
      :attributes="attributes"
      disable-page-swipe
      is-expanded
    >
      <template v-slot:day-content="{ day, attributes }">
        <div
          class="flex flex-col h-full z-10 overflow-hidden"
          @click="dayClicked(day)"
        >
          <span class="day-label text-sm text-gray-900">{{ day.day }}</span>
          <div class="flex-grow overflow-y-auto overflow-x-auto">
            <p
              v-for="attr in attributes"
              :key="attr.key"
              class="text-xs leading-tight rounded-sm p-1 mt-0 mb-1"
              :title="attr.customData.status"
              :class="attr.customData.class"
              @click="showData($event, attr.customData)"
            >
              {{ attr.customData.title }}
            </p>
          </div>
        </div>
      </template>
    </v-calendar>
    <div class="modal" :class="{ open_modal: showModal }" data-modal="modal">
      <div class="modal_overlay" data-modal-close="modal"></div>
      <div class="modal_wrap">
        <div class="modal_header">
          <div class="d_flex_btwn">
            <h3>{{ title }} - {{ this.form.label }}</h3>
            <span>
              <span
                data-modal-close="modal"
                class="close_icon close_icon_md"
                @click.prevent="closeModal"
              ></span>
            </span>
          </div>
        </div>
        <div class="modal_inner">
          <div class="modal_content modal_850p">
            <div class="row">
              <div class="col_6 pr_20">
                <div
                  :class="[
                    'form_row_inline',
                    { has_error: errorFor('leave_type') },
                  ]"
                >
                  <label>Leave type</label>
                  <div class="form_input">
                    <select class="form_global" v-model="form.leave_type">
                      <option value="annual">Annual</option>
                      <option value="sick">Sick</option>
                      <option value="compensatory">Compensatory</option>
                    </select>
                    <v-errors :errors="errorFor('leave_type')"></v-errors>
                  </div>
                </div>
                <div
                  :class="[
                    'form_row_inline',
                    { has_error: errorFor('reason') },
                  ]"
                >
                  <label class="">Reason</label>
                  <div class="form_input">
                    <textarea
                      type="text"
                      class="form_global"
                      rows="5"
                      v-model="form.reason"
                    ></textarea>
                    <v-errors :errors="errorFor('reason')"></v-errors>
                  </div>
                </div>
              </div>
              <div class="col_6 pr_20">
                <div
                  :class="[
                    'form_row_inline',
                    { has_error: errorFor('document') },
                  ]"
                >
                  <label> Document </label>
                  <div class="form_input center_horizontally">
                    <input
                      ref="document"
                      type="file"
                      class="form_global"
                      accept="image/png, image/gif, image/jpeg"
                      @input="onFileChange($event)"
                    />
                  </div>
                  <div class="form_row_inline mt_10" v-if="tempFile">
                    <label></label>
                    <div class="inner_img p_relative display_inline">
                      <div class="cross_ic" @click.prevent="deleteFile">
                        <i class="fas fa-times"></i>
                      </div>
                      <img :src="tempFile" alt="" height="100" width="100" />
                    </div>
                  </div>
                  <div v-else class="form_row_inline mt_10">
                    <label></label>
                    <img
                      v-if="form.document"
                      :src="form.document"
                      alt=""
                      class=""
                      width="100"
                      height="100"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div
                class="col_12"
                v-if="form.status && form.status != 'pending'"
              >
                <h4 class="text-danger">
                  Note: You can not update approved or rejected request
                </h4>
              </div>
              <div class="col_6">
                <div class="form_row_inline">
                  <label></label>
                  <div class="form_input">
                    <template v-if="form.id && form.status == 'pending'">
                      <button
                        class="btn btn_primary"
                        :disabled="lyLoading"
                        @click.prevent="update"
                      >
                        Update
                      </button>
                      <button
                        class="btn btn_danger ml_10"
                        :disabled="lyLoading"
                        @click.prevent="deleteRecord()"
                      >
                        Delete
                      </button>
                    </template>

                    <button
                      class="btn btn_primary"
                      :disabled="lyLoading"
                      @click.prevent="submit"
                      v-if="!form.id"
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  data() {
    return {
      masks: {
        weekdays: 'WWW',
      },
      attributes: [],
      showModal: false,
      form: {
        start_date: '',
        end_date: '',
        reason: '',
        document: '',
        leave_type: 'annual',
      },
      tempFile: null,
      title: '',
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.axios.get('/leave-requests-for-calender').then((response) => {
        this.attributes = response.data.data;
      });
    },
    dayClicked(day) {
      this.form = {
        start_date: moment(day.date).format('YYYY-MM-DD'),
        end_date: moment(day.date).format('YYYY-MM-DD'),
        reason: '',
        document: '',
        leave_type: 'annual',
        label: moment(day.date).format('YYYY-MM-DD'),
      };
      this.title = 'Add Leave Request';
      this.showModal = true;
    },
    showData(e, data) {
      e.stopPropagation();
      this.form = { ...data };
      this.title = 'Edit Leave Request';
      this.showModal = true;
    },
    closeModal() {
      this.form = {};
      this.showModal = false;
    },
    onFileChange(event) {
      let files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;

      let file = event.target.files[0];
      this.form.document = file;

      this.tempFile = URL.createObjectURL(file);
    },
    deleteFile() {
      this.tempFile = null;
      this.form.document = null;
      this.$refs.document.value = null;
    },
    submit() {
      this.allErrors = null;
      this.lyLoading = true;

      let formData = new FormData();

      Object.keys(this.form).forEach((key) => {
        formData.append(key, this.form[key] ? this.form[key] : '');
      });

      this.axios
        .post('/leave-requests', formData)
        .then(() => {
          this.showSuccessMsg('Leave request Created Successfully!');
          this.loadData();
          this.form = {};
          this.showModal = false;
        })
        .catch((err) => {
          this.allErrors = err.response.data.errors;
          this.showFailMsg(err.response.data.message);
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },

    update() {
      this.allErrors = null;
      this.lyLoading = true;

      let formData = new FormData();

      formData.append('_method', 'PATCH');

      Object.keys(this.form).forEach((key) => {
        formData.append(key, this.form[key] ? this.form[key] : '');
      });

      this.axios
        .post('/leave-requests/' + this.form.id, formData)
        .then(() => {
          this.showSuccessMsg('Leave request Update Successfully!');
          this.loadData();
          this.form = {};
          this.showModal = false;
        })
        .catch((err) => {
          this.allErrors = err.response.data.errors;
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },
    deleteRecord() {
      this.$swal({
        title: 'Are you sure want to delete?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.delete('/leave-requests/' + this.form.id).then(() => {
            this.showSuccessMsg('Data has been deleted!');
            this.loadData();
            this.form = {};
            this.showModal = false;
          });
        }
      });
    },
  },
};
</script>

<style scoped>
::-webkit-scrollbar {
  width: 0px;
}
::-webkit-scrollbar-track {
  display: none;
}

::v-deep(.custom-calendar.vc-container) {
  --day-border: 1px solid #b8c2cc;
  --day-border-highlight: 1px solid #b8c2cc;
  --day-width: 90px;
  --day-height: 90px;
  --weekday-bg: #f8fafc;
  --weekday-border: 1px solid #eaeaea;

  border-radius: 0;
  width: 100%;
}

::v-deep(.custom-calendar.vc-container .vc-header) {
  /* background-color: #f1f5f8; */
  /* padding: 10px 0; */
  height: 48px;
  margin-top: 0;
}

::v-deep(.custom-calendar.vc-container .vc-weeks) {
  padding: 0;
}

::v-deep(.custom-calendar.vc-container .vc-weekday) {
  background-color: var(--weekday-bg);
  border-bottom: var(--weekday-border);
  border-top: var(--weekday-border);
  padding: 5px 0;
}

::v-deep(.custom-calendar.vc-container .vc-day) {
  padding: 0 5px 3px 5px;
  text-align: left;
  height: var(--day-height);
  min-width: var(--day-width);
  background-color: white;
}
::v-deep(.custom-calendar.vc-container .vc-day.weekday-1),
::v-deep(.custom-calendar.vc-container .vc-day.weekday-7) {
  background-color: #eff8ff;
}
::v-deep(.custom-calendar.vc-container .vc-day:not(.on-bottom)) {
  border-bottom: var(--day-border);
}
::v-deep(.custom-calendar.vc-container .vc-day.weekday-1:not(.on-bottom)) {
  border-bottom: var(--day-border-highlight);
}
::v-deep(.custom-calendar.vc-container .vc-day:not(.on-right)) {
  border-right: var(--day-border);
}

::v-deep(.custom-calendar.vc-container .vc-day-dots) {
  margin-bottom: 5px;
}

::v-deep(.custom-calendar .vc-header .vc-title-wrapper .vc-title) {
  /* opacity: 1 !important; */
  /* background: red !important; */
  /* color: red; */
  background: transparent;
}
::v-deep(.custom-calendar .vc-header .vc-title:hover) {
  opacity: 1;
}

::v-deep(.custom-calendar .vc-weeks .vc-day) {
  text-align: center;
  padding: 5px;
  min-height: 60px;
  height: auto;
}
::v-deep(.custom-calendar .bg-info) {
  background: rgba(66, 153, 225);
  color: #fff;
  padding: 5px;
  margin-top: 5px;
  margin-bottom: 5px;
  cursor: pointer;
}
::v-deep(.custom-calendar .bg-success) {
  background: rgba(56, 178, 172);
  color: #fff;
  padding: 5px;
  margin-top: 5px;
  margin-bottom: 5px;
  cursor: pointer;
}
::v-deep(.custom-calendar .bg-danger) {
  background: rgba(229, 62, 62);
  color: #fff;
  padding: 5px;
  margin-top: 5px;
  margin-bottom: 5px;
  cursor: pointer;
}
.color_green {
  color: #16a34a;
}
.text-danger {
  color: #dc2626;
}
.float-right {
  float: right;
  cursor: pointer;
}
</style>
